import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Brightness4 as Brightness4Icon, DarkMode as DarkModeIcon, LightMode as LightModeIcon, } from '@mui/icons-material';
import { Box, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useWidgetConfig } from '../../providers';
import { useAppearance } from '../../stores';
import { HiddenUI } from '../../types';
import { ToggleButton } from './ColorSchemeButtonGroup.style';
export const ColorSchemeButtonGroup = () => {
    const { t } = useTranslation();
    const { disableAppearance, hiddenUI } = useWidgetConfig();
    const [appearance, setAppearance] = useAppearance();
    if (disableAppearance || (hiddenUI === null || hiddenUI === void 0 ? void 0 : hiddenUI.includes(HiddenUI.Appearance))) {
        return null;
    }
    return (_jsx(Box, Object.assign({ pb: 2 }, { children: _jsxs(ToggleButtonGroup, Object.assign({ color: "primary", value: appearance, onChange: (_, value) => {
                if (value) {
                    setAppearance(value);
                }
            }, exclusive: true, fullWidth: true }, { children: [_jsxs(ToggleButton, Object.assign({ value: "light" }, { children: [_jsx(LightModeIcon, { sx: { marginRight: 1 } }), t('button.light')] })), _jsxs(ToggleButton, Object.assign({ value: "dark" }, { children: [_jsx(DarkModeIcon, { sx: { marginRight: 1 } }), t('button.dark')] })), _jsxs(ToggleButton, Object.assign({ value: "auto" }, { children: [_jsx(Brightness4Icon, { sx: { marginRight: 1 } }), t('button.auto')] }))] })) })));
};
